module.exports = __webpack_public_path__ + "static/media/4.1fe40c32.jpg";